import { ButtonGroup, IconButton } from '@chakra-ui/react'
import { SimpleLeftArrow, SimpleRightArrow } from 'components/icons'
import { useMiniCalendar } from '../../../../contexts/MiniCalendarContext/Provider'
import { addMonths, subMonths } from 'date-fns'

export default function Controls() {
  const { view, activeDay, setActiveDay } = useMiniCalendar()

  function previous() {
    if (view === 'MONTH') {
      const nextMonth = subMonths(new Date(activeDay), 1)
      setActiveDay(nextMonth)
    }
  }

  function next() {
    if (view === 'MONTH') {
      const nextMonth = addMonths(new Date(activeDay), 1)
      setActiveDay(nextMonth)
    }
  }

  return (
    <ButtonGroup size="xs" isAttached variant="outline">
      <IconButton aria-label="arrow" w="7" icon={<SimpleLeftArrow boxSize={4} />} onClick={() => previous()} />
      <IconButton aria-label="arrow" w="7" icon={<SimpleRightArrow boxSize={4} />} onClick={() => next()} />
    </ButtonGroup>
  )
}
